import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  query: z.string().min(1, 'Search query is required'),
  type: z.enum(['web', 'code', 'docs']).optional().default('web'),
  num: z.number().min(1).max(10).optional().default(5),
});

export type InputType = z.infer<typeof schema>;

export interface SearchResult {
  title: string;
  description: string;
  url: string;
  favicon: string;
  image?: string;
  position: number;
}

export interface OutputType {
  query: string;
  results: SearchResult[];
  totalResults?: number;
  searchTime?: number;
}

export const postWebSearch = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/ai/websearch`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    try {
      const errorObject = superjson.parse<{ error: string }>(await result.text());
      throw new Error(errorObject.error);
    } catch (e) {
      if (e instanceof Error && e.message !== 'Unexpected end of JSON input') {
        throw e;
      }
      throw new Error(`Request failed with status ${result.status}`);
    }
  }

  return superjson.parse<OutputType>(await result.text());
};
